// extracted by mini-css-extract-plugin
module.exports = {"root":"AppBar_root__2rw1f","title":"AppBar_title__1kYgK","actionsContainer":"AppBar_actionsContainer__2VUr8","tabsContainer":"AppBar_tabsContainer__XMGg6"};